/**
 * ConfirmationDialog.js
 * Handles confirmation dialogs using HTML template
 */

class ConfirmationDialog {
  constructor() {
    this.dialog = null;
    this.overlay = null;
    this.container = null;
    this.titleElement = null;
    this.messageElement = null;
    this.confirmButton = null;
    this.cancelButton = null;
    this.currentResolver = null;
    this.isInitialized = false;
  }

  /**
   * Initialize the dialog
   */
  init() {
    if (this.isInitialized) return;

    this.dialog = document.getElementById('confirmation-dialog');
    this.overlay = this.dialog.querySelector('.confirmation-dialog-overlay');
    this.container = this.dialog.querySelector('.confirmation-dialog-container');
    this.titleElement = document.getElementById('dialog-title');
    this.messageElement = document.getElementById('dialog-message');
    this.confirmButton = document.getElementById('dialog-confirm');
    this.cancelButton = document.getElementById('dialog-cancel');

    this.bindEvents();
    this.isInitialized = true;
  }

  /**
   * Bind event handlers
   */
  bindEvents() {
    if (!this.dialog) return;

    this.confirmButton.addEventListener('click', () => this.close(true));
    this.cancelButton.addEventListener('click', () => this.close(false));

    // Handle escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.currentResolver && !this.dialog.classList.contains('hidden')) {
        this.close(false);
      }
    });

    // Handle backdrop click
    this.overlay.addEventListener('click', () => {
      this.close(false);
    });
  }

  /**
   * Show the confirmation dialog
   */
  show(options = {}) {
    if (!this.isInitialized) {
      this.init();
    }

    const {
      title = 'Confirm Removal',
      message = 'Are you sure you want to remove this item from your cart?',
      confirmText = 'Yes, Remove',
      cancelText = 'Cancel'
    } = options;

    // Update dialog content
    this.titleElement.textContent = title;
    this.messageElement.textContent = message;
    this.confirmButton.textContent = confirmText;
    this.cancelButton.textContent = cancelText;

    // Show dialog
    this.dialog.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    // Trigger animation
    setTimeout(() => {
      this.dialog.classList.add('show');
    }, 10);

    // Focus on cancel button after animation
    setTimeout(() => {
      this.cancelButton.focus();
    }, 150);

    // Return a promise
    return new Promise((resolve) => {
      this.currentResolver = resolve;
    });
  }

  /**
   * Close the dialog
   */
  close(confirmed) {
    if (!this.dialog) return;

    this.dialog.classList.remove('show');

    // Complete close after animation
    setTimeout(() => {
      this.dialog.classList.add('hidden');
      document.body.style.overflow = '';

      if (this.currentResolver) {
        this.currentResolver(confirmed);
        this.currentResolver = null;
      }
    }, 300);
  }
}

// Create singleton instance
window.ConfirmationDialog = new ConfirmationDialog(); 